module.exports = __webpack_public_path__ + "static/media/hotel.12935ae2.webp";